import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { getVehiclesScores } from '../../services/VehiclesService';
import { VehiclesScores } from '../../types/Vehicles';

function useGetVehiclesScores(
  fleetId: string,
  fromDate: string,
  toDate: string,
  query?: string,
): UseQueryResult<VehiclesScores> {
  return useQuery(
    ['vehicles-scores', fleetId, fromDate, toDate, query],
    async (): Promise<VehiclesScores> => getVehiclesScores(fleetId, fromDate, toDate, query),
    {
      retry: 1,
      retryDelay: 3000,
      keepPreviousData: true,
    },
  );
}

export default useGetVehiclesScores;
